import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatTime } from './helpers';

const loadFont = async (url) => {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    return arrayBuffer;
};

// Convert ArrayBuffer to binary string (standard for jsPDF addFileToVFS)
const arrayBufferToBinaryString = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return binary;
};

export const generatePDFReport = async (review, project, feedbacks) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    try {
        // Load Custom Font for Vietnamese (Roboto from CDN)
        // Using a CORS-friendly CDN for Roboto TTF
        const fontUrl = 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf';
        const fontData = await loadFont(fontUrl);
        const fontBinary = arrayBufferToBinaryString(fontData);

        doc.addFileToVFS('Roboto-Regular.ttf', fontBinary);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto'); // Set as default
    } catch (e) {
        console.error("Failed to load custom font. Fallback to default.", e);
        // Alert user if font fails? Or just proceed.
    }

    // -- Header --
    doc.setFillColor(26, 26, 26); // Dark background
    doc.rect(0, 0, pageWidth, 40, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(22);
    doc.text("Feedback Report", 14, 20);

    doc.setFontSize(10);
    doc.setTextColor(200, 200, 200);
    doc.text(`Project: ${project?.title || 'Untitled'}`, 14, 30);
    doc.text(`Video: ${review.title}`, 14, 35);
    doc.text(`Date: ${new Date().toLocaleDateString()}`, pageWidth - 14, 35, { align: 'right' });

    // -- Stats --
    const total = feedbacks.length;
    const resolved = feedbacks.filter(f => f.isResolved).length;
    const pending = total - resolved;

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.text(`Summary: ${total} comments (${resolved} resolved, ${pending} pending)`, 14, 50);

    // -- Table --
    const tableColumn = ["Time", "Author", "Feedback", "Status"];
    const tableRows = [];

    feedbacks.forEach(ticket => {
        const status = ticket.isResolved ? "Resolved" : "Pending";
        const feedbackData = [
            formatTime(ticket.timestamp),
            ticket.authorName,
            ticket.text + (ticket.reply ? `\n[Reply]: ${ticket.reply}` : ""), // Append reply
            status
        ];
        tableRows.push(feedbackData);
    });

    autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 55,
        theme: 'grid',
        headStyles: {
            fillColor: [0, 168, 232], // Cyan blue header
            font: 'Roboto' // Use custom font in header
        },
        styles: {
            fontSize: 10,
            cellPadding: 3,
            font: 'Roboto', // Use custom font in cells
            fontStyle: 'normal'
        },
        columnStyles: {
            0: { cellWidth: 20 },
            1: { cellWidth: 30 },
            2: { cellWidth: 'auto' }, // Feedback column expands
            3: { cellWidth: 25 }
        },
        didDrawCell: (data) => {
            // Future: Could verify if we can draw the annotation image here.
            // But images in tables are tricky in autoTable without pre-processing.
        }
    });

    // -- Footer --
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text('Generated by HeyMedia Tool', pageWidth / 2, doc.internal.pageSize.height - 10, { align: 'center' });
    }

    doc.save(`Feedback_Report_${review.title.replace(/\s+/g, '_')}.pdf`);
};
